import { Injectable } from '@angular/core';
import {ItemSummaryItemService} from './item-summary-item.service';
import {HttpClient} from '@angular/common/http';
import {HttpRequestErrorHandler} from '@rbaip/ui-component';
import { catchError } from 'rxjs/operators';
import {Observable} from 'rxjs';
import {appConfig} from '../app.config';
import {Asset} from '../domain/item';

@Injectable({
  providedIn: 'root'
})
export class ItemSummaryAssetService extends ItemSummaryItemService {

  getAssetUrl = '/api/asset/:assetId/details';
  private readonly saveAssetInfoUrl = '/api/asset/:assetId/assetinformation';
  private readonly saveAssetSaleInfoUrl = '/api/asset/:assetId/assetSaleInformation';
  private readonly  assetPhotoUrl = '/api/assets/:assetId/photos';

  constructor(private http: HttpClient) {
    super();
  }

  public getAsset(assetId: number): void {
    let url = this.getAssetUrl;
    url = url.replace(':assetId', assetId.toString());
    this.http.get(url, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('getAsset', {}))
      )
      .subscribe(response => {
        this.data.asset = Object.assign(new Asset(), response);

        if (this.data.asset) {
          this.assetServiceCallback.next(this.data.asset);
        }
      });
  }

  public saveAssetInformation(asset: Asset): Observable<any> {
    const url = this.saveAssetInfoUrl.replace(':assetId', String(asset.assetId));
    return this.http.post<any>(url, asset, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('saveAssetInfo', false))
      );
  }


  public saveAssetSaleInfo(asset: Asset): Observable<any> {
    const url = this.saveAssetSaleInfoUrl.replace(':assetId', String(asset.assetId));
    return this.http.post<any>(url, asset, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('saveAssetInfo', false))
      );

  }

  public saveAssetBudget(assetId: number, rnrBudget: number, haulingBudget: number): Observable<any> {
    let url = '/api/asset/:assetId/rnrBudget/:rnrBudget/haulingBudget/:haulingBudget/updateBudget';
    url = url.replace(':assetId', assetId.toString() );
    url = url.replace(':rnrBudget', rnrBudget > 0 ? rnrBudget.toString() : '0');
    url = url.replace(':haulingBudget', haulingBudget > 0 ? haulingBudget.toString() : '0');
    const body = '';
    return this.http.put(url, body, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('updatebudget', null))
      );
  }

  public reconsignAsset(equipId: number, contractId: number): Observable<any> {
    const url = `/api/equipment/${equipId}/reconsign?contractId=${contractId}`;
    return this.http.post<any>(url, '', appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('', false))
      );
  }

  public resellAbandonedEquip(equipId: number): Observable<any> {
    const url = `/api/equip/${equipId}/abandoned/resell`;
    return this.http.post<any>(url, '', appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('resellAbandonedEquip', false))
      );
  }

  public resellNotSoldAssets(contractId: number, assets?: Asset[]): Observable<any> {
    const url = `/api/equip/not-sold/resell?contractId=${contractId}`;
    return this.http.post<any>(url, assets, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('resellNotSoldAssets', false))
      );
  }

  public duplicateSerialNumber(serialNumber: string, itemId: number, assetPackageId: number): Observable<any> {
    itemId = itemId ? itemId : 0;
    const url = `/api/acgId/${assetPackageId}/assetId/${itemId}/serialNumber`;
    const body = serialNumber;
    return this.http.put<any>(url, body, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('duplicateSerialNumber', false))
      );
  }

  public duplicateSellerTracking(sellerTrackingCode: string,  itemId: number, assetPackageId?: number): Observable<any> {
    itemId = itemId ? itemId : 0;
    const url = `/api/acgId/${assetPackageId}/assetId/${itemId}/sellerTrackingCode`;
    const body = sellerTrackingCode;
    return this.http.put<any>(url, body, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('duplicateSellerTracking', false))
      );
  }

  public getAssetPhoto(itemId: number): Observable<any> {
    let url = this.assetPhotoUrl;
    url = url.replace(':assetId', itemId.toString() );
    return this.http.get(url, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('getAsset', {}))
      );
  }

  public markAsReviewed(equipIds: number[]){
    return undefined;
  }

  public isCheckListChanged(equipId: number,assetTypeId: number): Observable<any>{
    return undefined;
  }
}
